import React from 'react'
import { useRecoilState } from 'recoil'
import { Modal } from '/src/components/common'
import { StoreStockList } from '../list/StoreList'
import { storeStockModalDisplayState } from './storeStockModalState'

import './store_stock_modal.scss'

export const StoreStockModal = ({ product_variation_id, quantity }) => {
  const [display, setDisplay] = useRecoilState(storeStockModalDisplayState)

  return (
    <Modal display={display} setDisplay={setDisplay}>
      <StoreStockList 
        product_variation_id={product_variation_id} 
        quantity={quantity}
        setDisplay={setDisplay} />
    </Modal>
  )
}

export default StoreStockModal